import './selection.scss';

import { getOffset, smoothScrollTo } from '../../js/helper';

class Selection {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-selection',
            backAttr: 'back',
            handleAttr: 'handle',
            optionAttr: 'option',
            contentAttr: 'content',
            productsAttr: 'products',
            activeClassname: 'is--active',
            offset: 0
        };

        this.settings = Object.assign({}, defaults, options);

        this.$selection = element;
        this.$selectionOptions = this.$selection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.optionAttr + '"]');
        this.$selectionContents = this.$selection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        this.$selectionProducts = this.$selection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.productsAttr + '"]');
        this.$selectionHandles = this.$selection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.handleAttr + '"]');
        this.$selectionBacks = this.$selection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.backAttr + '"]');
        this.$header = document.querySelector('[data-header="root"]');

        if (this.$selectionOptions.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.optionAttr + '"]');
            return;
        }

        if (this.$selectionContents.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
            return;
        }

        if (this.$selectionHandles.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.handleAttr + '"]');
            return;
        }

        if (this.$selectionBacks.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.backAttr + '"]');
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        for (let i = 0; i < this.$selectionOptions.length; i++) {
            const $selectionOption = this.$selectionOptions[i];
            const $selectionHandle = $selectionOption.querySelector('[' + this.settings.initAttr + '="' + this.settings.handleAttr + '"]');
            const indexer = $selectionHandle.getAttribute('rel');

            $selectionHandle.addEventListener('click', (e) => {
                if (this.$selection.classList.contains(this.settings.activeClassname)) {
                    this.$selection.classList.remove(this.settings.activeClassname);
                } else {
                    this.$selection.classList.add(this.settings.activeClassname);
                }

                this.showOptionContent(indexer);

                e.preventDefault();
            });
        }

        for (let i = 0; i < this.$selectionBacks.length; i++) {
            const $backButton = this.$selectionBacks[i];

            $backButton.addEventListener('click', (e) => {
                if (this.$selection.classList.contains(this.settings.activeClassname)) {
                    this.$selection.classList.remove(this.settings.activeClassname);
                }

                this.showOptionContent();

                e.preventDefault();
            });
        }
    }

    showOptionContent (index) {
        let offset = this.settings.offset;
        if (this.$header !== null) {
            offset = this.$header.offsetHeight + this.settings.offset;
        }

        for (let i = 0; i < this.$selectionContents.length; i++) {
            const $currentContent = this.$selectionContents[i];

            $currentContent.classList.remove(this.settings.activeClassname);
        }

        if (this.$selectionProducts !== null) {
            for (let i = 0; i < this.$selectionProducts.length; i++) {
                const $currentProducts = this.$selectionProducts[i];

                $currentProducts.classList.remove(this.settings.activeClassname);
            }
        }

        if (index) {
            const $content = this.$selection.querySelector('#content' + index);
            const position = getOffset(this.$selection);

            $content.classList.add('is--active');

            if (this.$selectionProducts !== null) {
                const $products = this.$selection.querySelector('#products' + index);

                if ($products !== null) {
                    $products.classList.add('is--active');
                }
            }
            smoothScrollTo(0, position.top - offset, 250);
        } else {
            const position = getOffset(this.$selection);
            smoothScrollTo(0, position.top - offset, 250);
        }
    }
}

export { Selection };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $selections = $context.querySelectorAll('[data-selection="root"]');

        if ($selections.length > 0) {
            for (let i = 0; i < $selections.length; i++) {
                const $selection = new Selection($selections[i]);
                $selection.initialize();
            }
        }
    }
});
